import { createAsyncThunk } from '@reduxjs/toolkit';

import { resetSlicesStateThunk } from '../../../../main/slices/app-lifecycle/thunks/reset-slices-state.thunk.ts';
import { ThunkApiConfigType } from '../../../../main/store/main.store.ts';
import { getAwsAuthUtil } from '../../../../main/utils/aws/aws-auth.util.ts';

import { setCurrentAccount } from '../../accounts/accounts.slice.ts';
import { fetchAndAssignChildProfileThunk } from '../../accounts/thunks/fetch-and-assign-child-profile.thunk.ts';

import { AUTH_SLICE_NAME } from '../auth.slice.types.ts';

import { identifyUserTrackersThunk } from './identify-user-trackers.thunk.ts';
import { resetUserTrackersThunk } from './reset-user-trackers.thunk.ts';

interface ReturnType {
  email: string;
  userId: string;
  preferredName?: string;
  studentId?: string;
}

export const fetchAndAssignCurrentUserThunk = createAsyncThunk<ReturnType | undefined, void, ThunkApiConfigType>(
  `${AUTH_SLICE_NAME}/fetchAndAssignCurrentUser`,
  async (_, thunkAPI) => {
    const result = await getAwsAuthUtil().getCurrentUser();
    if (!result) {
      thunkAPI.dispatch(resetSlicesStateThunk());
      thunkAPI.dispatch(resetUserTrackersThunk());
      return;
    }

    thunkAPI.dispatch(
      identifyUserTrackersThunk({ email: result.email, userId: result.userId, preferredName: result.preferredName })
    );

    thunkAPI.dispatch(
      setCurrentAccount({
        userId: result.userId,
        studentId: result.studentId,
        email: result.email,
        preferredName: result.preferredName ?? '',
      })
    );
    await thunkAPI.dispatch(fetchAndAssignChildProfileThunk()).unwrap();
    return result;
  }
);
